import React from 'react';
import './TutorialBookIcon.css';
import {WAR_COLOR} from '../../../styles/constants';

const TUTORIAL_BOOK_ICON_PATH = '/img/icons/rules_white.png';

// Недоигранная глава обучения — книжка красная: в истории матчей ее видно
// сразу, не вчитываясь в подписи
export const TUTORIAL_BOOK_ICON_COLORS = Object.freeze({
  COMPLETED: '#FFFFFF',
  UNFINISHED: WAR_COLOR,
});

/**
 * Иконка записи обучения в истории матчей (книжка правил). Перекрашивается
 * маской, поэтому это span с mask-image, а не img: белый PNG одноцветной
 * заливке не поддается
 */
export function TutorialBookIcon({isUnfinished = false, className = ''}) {
  const label = isUnfinished ? 'Обучение не завершено' : 'Глава обучения';
  return (
    <span
      className={`tutorial-book-icon ${isUnfinished ? 'tutorial-book-icon_unfinished' : ''} ${className}`}
      style={{
        backgroundColor: isUnfinished ? TUTORIAL_BOOK_ICON_COLORS.UNFINISHED : TUTORIAL_BOOK_ICON_COLORS.COMPLETED,
        WebkitMaskImage: `url("${TUTORIAL_BOOK_ICON_PATH}")`,
        maskImage: `url("${TUTORIAL_BOOK_ICON_PATH}")`,
      }}
      role={'img'}
      aria-label={label}
      title={label}
    />
  );
}
